import { render } from "./AuthBody.vue?vue&type=template&id=57deec47"
import script from "./AuthBody.vue?vue&type=script&lang=js"
export * from "./AuthBody.vue?vue&type=script&lang=js"

import "./AuthBody.vue?vue&type=style&index=0&id=57deec47&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__